import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  /**
   * The error message of the input component.
   */
  error?: React.ReactNode;

  /**
   * Whether the text area component is resizable.
   */
  resize?: boolean;

  /**
   * Specifies the initial visible number of lines in a text area (initial height).
   */
  rows?: number;

  /**
   * The ref of the input component.
   */
  ref?: React.Ref<HTMLTextAreaElement>;
};

export const TextAreaBase: React.FC<IProps> = ({
  className,
  error,
  resize,
  ...props
}) => {
  const textAreaCls = textAreaStyle.cls({ className, resize });
  return <textarea {...props} aria-invalid={!!error} className={textAreaCls} />;
};

const textAreaStyle = tsv({
  base: "fs-form-field fs-text-area",
  variants: {
    resize: {
      false: "resize-none",
    },
  },
});
